import { SignIn, Show } from '@clerk/react';

import { ChatWorkspace } from './components/ChatWorkspace';
import { TabsProvider } from './hooks/useSessions';
import { ApiProvider } from './lib/api-context';

/**
 * Top-level app shell. Clerk's `<Show when=...>` gates the chat
 * workspace — unauthenticated users see only the SignIn card. Once
 * signed in, ChatWorkspace owns tab state, the active session, and
 * the streaming chat pane. `<Show>` returns null while auth is
 * loading, so we don't render either branch with a flashy interstitial.
 */
export function App() {
  return (
    <>
      <Show when="signed-out">
        <main
          className="flex min-h-screen items-center justify-center px-4"
          style={{ paddingBlock: 'env(safe-area-inset-top) env(safe-area-inset-bottom)' }}
        >
          <div className="flex w-full max-w-md flex-col gap-6">
            <header className="text-center">
              <h1 className="text-2xl font-semibold tracking-tight" translate="no">
                Bluebird
              </h1>
              <p className="mt-1 text-sm opacity-70">
                Sign in to continue to your personal assistant.
              </p>
            </header>
            <div className="flex justify-center">
              <SignIn routing="hash" />
            </div>
          </div>
        </main>
      </Show>
      <Show when="signed-in">
        <ApiProvider>
          <TabsProvider>
            <ChatWorkspace />
          </TabsProvider>
        </ApiProvider>
      </Show>
    </>
  );
}
